import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './AccessPendingScreen.module.css';

// RepBuddy-branded holding screen for a verified account that has not been admitted yet.
// During Beta, accounts are let in by hand (allowed_users, or the global chat_enabled
// switch), so this is a normal step of the sign-up flow rather than a pre-launch page: it
// says the account is under review and sets expectations for Beta. `onEnter` re-checks
// access so an admitted user gets in without reloading (useAccessStatus also re-checks on
// tab focus).
export default function AccessPendingScreen({ onEnter }) {
  const { user, signOut } = useAuth();
  const isFounding = user?.user_metadata?.founding_member === true;
  // Official logo at /logo.png; fall back to the lettermark if it's missing.
  const [logoOk, setLogoOk] = useState(true);

  return (
    <div className={styles.screen}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          {logoOk ? (
            <img
              className={styles.logoImg}
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="RepBuddy"
              onError={() => setLogoOk(false)}
            />
          ) : (
            <span className={styles.logoMark}>R</span>
          )}
          <span className={styles.logoName}>RepBuddy</span>
        </div>

        <span className={styles.eyebrow}>{isFounding ? 'Founding Member · Beta' : 'Beta'}</span>
        <h1 className={styles.headline}>Your account is being reviewed.</h1>

        <p className={styles.sub}>
          Thanks for signing up. We’re letting people in by hand during Beta, and we’ll email
          you the moment your account is live. RepBuddy is still in Beta, so expect a few rough
          edges while we polish things up.
          {isFounding && <> Your <strong>founding price is locked in</strong>.</>}
        </p>

        <div className={styles.actionBox}>
          <button className={styles.enterBtn} type="button" onClick={onEnter}>
            Check my access
          </button>
          <p className={styles.trialNote}>
            Your 7-day free trial starts the day your account is live.
          </p>
        </div>

        {/* Invite users to browse the marketing site while they wait */}
        <div className={styles.explore}>
          <p className={styles.exploreText}>In the meantime, feel free to look around.</p>
          <Link className={styles.exploreBtn} to="/">Explore the RepBuddy site →</Link>
        </div>

        <div className={styles.footer}>
          {user?.email && <span className={styles.who}>Signed in as {user.email}</span>}
          <button className={styles.signout} onClick={signOut}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
